<template>
  <div class="column content-box">
    <woot-modal-header
      :header-title="$t('EVENTS.ADD.TITLE')"
      :header-content="$t('EVENTS.ADD.DESC')"
    />
    <event-form
      :is-submitting="uiFlags.isCreating"
      @submit="onSubmit"
      @cancel="onClose"
    />
  </div>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import { mapGetters } from 'vuex';
import EventForm from './EventForm';

export default {
  components: {
    EventForm,
  },
  mixins: [alertMixin],
  props: {
    onClose: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      uiFlags: 'events/getUIFlags',
    }),
  },
  methods: {
    async onSubmit(eventData) {
      try {
        await this.$store.dispatch('events/create', eventData);
        this.showAlert(this.$t('EVENTS.ADD.API.SUCCESS_MESSAGE'));
        this.onClose();
      } catch (error) {
        const message =
          error.response?.data?.message ||
          this.$t('EVENTS.ADD.API.ERROR_MESSAGE');
        this.showAlert(message);
      }
    },
  },
};
</script>
